import React, { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { useLang } from "@/contexts/LangContext";
import { toast } from "sonner";

export default function Register() {
  const { register } = useAuth();
  const { t } = useLang();
  const nav = useNavigate();
  const [params] = useSearchParams();
  const program = params.get("program");
  const [form, setForm] = useState({ email: "", password: "", full_name: "" });
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await register(form.email, form.password, form.full_name);
      toast.success("Account created");
      nav(program ? `/programs?select=${program}` : "/dashboard");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Registration failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-[calc(100vh-64px)] flex items-center justify-center px-6 py-16">
      <div className="w-full max-w-md surface p-10" data-testid="register-card">
        <div className="text-[10px] uppercase tracking-widest text-[#CCFF00] font-mono">X1K // Onboarding</div>
        <h1 className="font-display text-3xl font-bold mt-2">{t("register_title")}</h1>
        <form onSubmit={onSubmit} className="mt-8 space-y-4">
          <Field label={t("full_name")} type="text" value={form.full_name} onChange={(v) => setForm({ ...form, full_name: v })} testid="register-name-input" required={false} />
          <Field label={t("email")} type="email" value={form.email} onChange={(v) => setForm({ ...form, email: v })} testid="register-email-input" />
          <Field label={t("password")} type="password" value={form.password} onChange={(v) => setForm({ ...form, password: v })} testid="register-password-input" />
          <button disabled={loading} data-testid="register-submit-button" type="submit" className="btn-acid w-full">
            {loading ? "…" : t("submit")}
          </button>
        </form>
        <div className="mt-6 text-sm text-white/40 font-mono">
          {t("have_account")} <Link data-testid="register-to-login-link" to="/login" className="text-[#CCFF00] hover:underline">{t("nav_login")}</Link>
        </div>
      </div>
    </div>
  );
}

function Field({ label, type, value, onChange, testid, required = true }) {
  return (
    <label className="block">
      <div className="text-[10px] uppercase tracking-widest text-white/40 font-mono mb-2">{label}</div>
      <input
        data-testid={testid}
        type={type}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        required={required}
        className="w-full bg-[#0A0A0A] border border-[#222] focus:border-[#CCFF00] focus:outline-none px-4 py-3 font-mono text-sm transition-colors"
      />
    </label>
  );
}
